import { createContext } from 'react'

const ConfigContext = createContext({
  loading: true,
})

export default ConfigContext
